export const meta = {
  id: 'word-break',
  name: 'Word Break Problem',
  category: 'DP',
  complexity: {
    time: 'O(n²)',
    space: 'O(n)'
  },
  description: 'Word Break Problem determines if a string can be segmented into a space-separated sequence of dictionary words using dynamic programming.'
};
